<script setup>
  import { storeToRefs } from "pinia";
  import { EmptyState } from "@/components/episto-ui/empty-state";
  import { useReportsV2Store } from "@stores/survey/reportsV2/reportsV2";
  import ReportV2Card from "./ReportV2Card.vue";

  const reportsStore = useReportsV2Store();
  const { filteredReports } = storeToRefs(reportsStore);

  defineEmits(["click", "download", "duplicate", "delete"]);
</script>

<template>
  <EmptyState
    v-if="filteredReports.length === 0"
    title="No report yet ..." />
  <div
    v-else
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
    <ReportV2Card
      v-for="report in filteredReports"
      :key="report.id"
      :report="report"
      @click="$emit('click', report)"
      @download="$emit('download', report)"
      @duplicate="$emit('duplicate', report)"
      @delete="$emit('delete', report)" />
  </div>
</template>
